export default __webpack_public_path__ + "assets/ogg/5ed6e0efee681ddbbbe3796ef2f5ea4e.ogg";